module.exports = __webpack_public_path__ + "rosacea_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_7_before.jpg
// module id = 990
// module chunks = 0